<template>
  <div class="navbar-container d-flex content align-items-center">
    <!-- Nav Menu Toggler -->
    <ul class="nav navbar-nav d-xl-none">
      <li class="nav-item">
        <b-link class="nav-link" @click="toggleVerticalMenuActive">
          <feather-icon icon="MenuIcon" size="21" />
        </b-link>
      </li>
      <li class="d-inline-block d-sm-none d-md-none d-lg-none">
        <VOVAT-logo />
      </li>
    </ul>
    <!-- Left Col -->
    <div class="bookmark-wrapper align-items-center flex-grow-1 d-none d-lg-flex">
      <!-- Bookmarks Container -->
      <!-- <bookmarks /> -->
      <b-button variant="primary pl-1 pr-1" size="sm" :to="{ name: 'article-create' }">
        <span class="text-nowrap">
          <feather-icon icon="FileTextIcon" /> {{ $t('Thêm mới bài viết') }} </span>
      </b-button>
      <router-link v-if="$can('article.draft', 'Article')" :to="{ name: 'article-draft' }" class="link-article"
        :class="($route.name == 'article-draft') ? 'active' : ''">Nhờ xử lý
        (<span id="top_total_draft">0</span>)</router-link>
      <router-link v-if="$can('article.approved', 'Article')" :to="{ name: 'article-approved' }" class="link-article"
        :class="($route.name == 'article-approved') ? 'active' : ''">Chờ
        duyệt (<span id="top_total_approved">0</span>)</router-link>
      <router-link v-if="$can('article.corrected', 'Article')" :to="{ name: 'article-corrected' }" class="link-article"
        :class="($route.name == 'article-corrected') ? 'active' : ''">Chờ xuất bản (<span
          id="top_total_corrected">0</span>)</router-link>

      <notification-message />
    </div>
    <b-navbar-nav class="nav align-items-center ml-auto">
      <!-- <locale /> -->
      <dark-Toggler class="d-none d-lg-block" />
      <search-bar />
      <!-- <cart-dropdown /> -->
      <notification-dropdown />
      <user-dropdown />
    </b-navbar-nav>
  </div>
</template>

<script>
import { BLink, BNavbarNav, BButton } from 'bootstrap-vue';
import VOVATLogo from '@core/layouts/components/Logo.vue';
import NotificationMessage from '@/views/notification/NotificationMessage.vue';
import Bookmarks from './components/Bookmarks.vue';
// import Locale from './components/Locale.vue';
import SearchBar from './components/SearchBar.vue';
import DarkToggler from './components/DarkToggler.vue';
// import CartDropdown from './components/CartDropdown.vue'
import NotificationDropdown from './components/NotificationDropdown.vue';
import UserDropdown from './components/UserDropdown.vue';

export default {
  components: {
    BLink,
    VOVATLogo,
    // Navbar Components
    BNavbarNav,
    BButton,
    Bookmarks,
    // Locale,
    SearchBar,
    DarkToggler,
    // CartDropdown,
    NotificationDropdown,
    UserDropdown,
    NotificationMessage,
  },
  props: {
    toggleVerticalMenuActive: {
      type: Function,
      default: () => { },
    },
  },
};
</script>
